"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchListResponseSchema = exports.SearchListItemSchema = void 0;
var zod_1 = require("zod");
var product_unit_1 = require("../product-unit");
/**
 * 레저 plp / srp 응답
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/~jusong.lee/pages/491947083/PLP+SRP#FE-API-Response---%EC%A7%80%EB%A9%B4-%EC%9D%91%EB%8B%B5%EB%AA%A8%EB%8D%B8}
 * */
exports.SearchListItemSchema = zod_1.z.union([
    product_unit_1.ProductUnitSchema,
    product_unit_1.RelatedKeywordSchema,
    product_unit_1.OmBannerSchema,
    product_unit_1.ImageBannerSchema,
]);
exports.SearchListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.SearchListItemSchema),
    paging: zod_1.z.object({ current: zod_1.z.number(), isLast: zod_1.z.boolean(), total: zod_1.z.number() }).nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
